import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { DeletePermitRegister, DeletePermitRegisterVariables } from "./__generated__/DeletePermitRegister";
import { CORE_PERMIT_REGISTER_FIELDS } from "../fragments/PermitRegister";

const DELETE_PERMIT_REGISTER = gql`
  ${CORE_PERMIT_REGISTER_FIELDS}
  mutation DeletePermitRegister($permitRegisterId: String!) {
    deletePermitRegister(input: { permitRegisterId: $permitRegisterId }) {
      register {
        ...CorePermitRegisterFields
      }
    }
  }
`;

export function useDeletePermitRegister() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    DeletePermitRegister,
    DeletePermitRegisterVariables
  >(DELETE_PERMIT_REGISTER, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
